<template>
  <div class="card mt-3">
    <div class="card-header border-0">
      <h5 class="card-title">اطلاعات محصول</h5>
    </div>
    <div class="card-body">
      <InputGroup label="نام محصول" required>
        <b-form-input
          type="text"
          v-model="realValue.title"
          placeholder="نام محصول"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="موجودی">
        <b-form-input
          v-model="realValue.quantity"
          type="number"
          min="0"
          placeholder="موجودی"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="بارکد">
        <b-form-input
          v-model="realValue.barcode"
          type="text"
          placeholder="بارکد"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="تامیین کننده">
        <treeselect
          :options="realSuppliers"
          :disabled="!canEditVariety"
          :searchable="true"
          noResultsText="موردی یافت نشد"
          v-model="realValue.supplier"
          :multiple="false"
          noOptionsText="موردی وجود ندارد"
          placeholder="انتخاب تامیین کننده"
        >
          <div slot="value-label" slot-scope="{ node }">{{ node.label }}</div>
        </treeselect>
      </InputGroup>
      <InputGroup label="SKU">
        <b-form-input
          v-model="realValue.sku"
          type="text"
          placeholder="SKU"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="شماره فاکتور">
        <b-form-input
          v-model="realValue.factor_id"
          type="text"
          placeholder="شماره فاکتور"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="کد حسابداری">
        <b-form-input
          v-model="realValue.accounting_code"
          type="text"
          placeholder="کد حسابداری"
          :disabled="!canEditVariety"
        />
      </InputGroup>
      <InputGroup label="دسته بندی" required>
        <treeselect
          :flat="true"
          :disabled="!canEditVariety"
          :searchable="true"
          :multiple="true"
          :options="realOptions"
          noChildrenText="فرزندی وجود ندارد"
          noOptionsText="موردی وجود ندارد"
          noResultsText="موردی یافت نشد"
          placeholder="انتخاب دسته بندی ها"
          v-model="realValue.categories"
        />
        <!--        <label slot="option-label" slot-scope="{ node, shouldShowCount, count, labelClassName, countClassName }"-->
        <!--               :class="labelClassName">-->
        <!--          {{ node.label }}-->
        <!--          <span v-show="false" v-if="shouldShowCount" :class="countClassName">({{ count }})</span>-->
        <!--        </label>-->
      </InputGroup>
      <InputGroup label="برند">
        <treeselect
          :options="realBrands"
          :disabled="!canEditVariety"
          :searchable="true"
          noResultsText="موردی یافت نشد"
          v-model="realValue.brand"
          :multiple="false"
          noOptionsText="موردی وجود ندارد"
          placeholder="انتخاب برند"
        >
          <div slot="value-label" slot-scope="{ node }">{{ node.label }}</div>
        </treeselect>
      </InputGroup>
      <InputGroup label="واحد" required>
        <treeselect
          :options="realUnits"
          :disabled="!canEditVariety"
          :searchable="true"
          noResultsText="موردی یافت نشد"
          v-model="realValue.unit"
          :multiple="false"
          noOptionsText="موردی وجود ندارد"
          placeholder="انتخاب واحد"
        >
          <div slot="value-label" slot-scope="{ node }">{{ node.label }}</div>
        </treeselect>
      </InputGroup>
      <InputGroup customClass="tag-container" label="تگ ها">
        <TreeselectAddable
          @add-option="addTag"
          placeholder="انتخاب تگ ها"
          v-model="realValue.tags"
          :options="realTags"
        />
      </InputGroup>
      <InputGroup label="لینک ویدیو">
        <b-form-input
          v-model="realValue.video_link"
          type="text"
          placeholder="لینک ویدیو"
        />
      </InputGroup>
      <InputGroup label="کاور ویدیو">
        <div class="custom-file">
          <input
            type="file"
            class="custom-file-input"
            id="videoCoverFileInput"
            accept="image/*"
            @change="videoCoverChange"
          />
          <label class="custom-file-label" for="videoCoverFileInput">{{
            videoCoverName
          }}</label>
        </div>
      </InputGroup>
      <div class="previewBox">
        <div class="previewVideo" v-if="realValue.video_cover_image">
          <img
            class="videoContent"
            :src="realValue.video_cover_image"
            alt="video cover"
          />
          <i
            @click="realValue.video_cover_image = null"
            class="fa fa-trash"
          ></i>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ProductInformationImpl from "@@/core/components/product/ProductInformation/ProductInformationImpl";
export default {
  extends: ProductInformationImpl,
};
</script>

<style scoped></style>
<style>
#productVideo {
  width: 100%;
  background: white;
  border-radius: 15px;
  padding: 10px 20px;
}
.previewVideo {
  width: 50%;
  position: relative;
}
@media (max-width: 768px) {
  .previewVideo {
    width: 100%;
  }
}
.previewBox {
  display: flex;
  gap: 10px;
}
.previewBox i {
  position: absolute;
  right: 5px;
  top: 5px;
  padding: 8px;
  background: red;
  color: white;
  border-radius: 8px;
}
</style>
